import apiAxios from "../services/axios.service";

export const getUserDetail = async () => {
  const {
    data: { id },
  } = await apiAxios.get("/users/me");
  return await apiAxios.get(`/user-details/${id}`);
};
